'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002e$002dDate$002dTime$002dException from "./java.time.-Date-Time-Exception.js";
import * as $j_java$002eutil$002e$002dAbstract$002dMap from "./java.util.-Abstract-Map.js";
var $p;
function $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V($thiz, fieldValues, field, value_$_lo, value_$_hi) {
  var current = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O(fieldValues, field, null);
  if ((current !== null)) {
    var $x_2 = current;
    var this$1_$_lo = $x_2.l;
    var this$1_$_hi = $x_2.h;
    var $x_1 = (((this$1_$_lo ^ value_$_lo) | (this$1_$_hi ^ value_$_hi)) !== 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((((("Invalid state, field: " + field) + " ") + current) + " conflicts with ") + field) + " ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
  } else {
    if ((field === null)) {
      var $x_3 = 0;
    } else {
      var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(field);
      var $x_3 = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    fieldValues.dO(field, $j_java$002elang$002e$002dObject.$bL(value_$_lo, value_$_hi), $x_3, false);
  }
}
export { $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V as $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V };
function $f_Ljava_time_chrono_Chronology__equals__O__Z($thiz, obj) {
  return ($is_Ljava_time_chrono_Chronology(obj) && (($thiz === obj) || ($j_java$002elang$002e$002dObject.$f_T__compareTo__T__I("ISO", "ISO") === 0)));
}
export { $f_Ljava_time_chrono_Chronology__equals__O__Z as $f_Ljava_time_chrono_Chronology__equals__O__Z };
function $f_Ljava_time_chrono_Chronology__hashCode__I($thiz) {
  return ($j_java$002elang$002e$002dObject.$systemIdentityHashCode($j_java$002elang$002e$002dObject.$objectGetClass($thiz)) ^ $j_java$002elang$002e$002dObject.$f_T__hashCode__I("ISO"));
}
export { $f_Ljava_time_chrono_Chronology__hashCode__I as $f_Ljava_time_chrono_Chronology__hashCode__I };
function $is_Ljava_time_chrono_Chronology(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.ce)));
}
export { $is_Ljava_time_chrono_Chronology as $is_Ljava_time_chrono_Chronology };
function $isArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ce)));
}
export { $isArrayOf_Ljava_time_chrono_Chronology as $isArrayOf_Ljava_time_chrono_Chronology };
